import React from 'react';
import { Link } from "@randajan/jet-react/dom/link";
import { Caption } from '@randajan/jet-react/dom/caption';
import { Reveal } from '../../../elements/Reveal/Reveal';

import "./Divisions.scss";

export const Divisions = (props)=>{
    const { services } = props;
    
    return (
        <article className="Divisions">
            <Reveal as="header">
                <span>Divize</span>
                <Caption>Komplexní služby ENERGOSPACE</Caption>
            </Reveal>
            <div className="Divisions__grid">
                {services.map((service, index)=>(
                    <Reveal className="Divisions__cardWrap" key={service.id} delay={index * 60}>
                        <Link className="Divisions__card" to={service.route}>
                            <span className="Divisions__tag">{service.menuTitle}</span>
                            <h3>{service.headline}</h3>
                            <p>{service.lead}</p>
                            <ul>
                                {service.primaryItems.slice(0, 3).map(item=><li key={item}>{item}</li>)}
                            </ul>
                            <span className="Divisions__more">Zobrazit detail</span>
                        </Link>
                    </Reveal>
                ))}
            </div>
        </article>
    )
}

